import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { wrapper } from './WithCeWrapperWrapper.module.css';

/**
 * HOC: default wrapper for content elements
 * @param {*} options option not used at this time
 * @example
 * export default withCeWrapper()(Gallery);
 */
const withCeWrapper = (_options?) => (WrappedComponent) => {
  /**
   * withCeWrapper wrapper component
   * @param {*} props
   */
  const WithCeWrapperWrapper = (props) => {
    const { className, header, ...restProps } = props;

    return (
      // eslint-disable-next-line react/jsx-filename-extension
      <div className={classNames(className, wrapper, 'ce')}>
        {header}
        <WrappedComponent {...restProps} />
      </div>
    );
  };

  WithCeWrapperWrapper.propTypes = {
    /** css classes */
    className: PropTypes.string,
    /** content element header */
    header: PropTypes.node,
  };

  WithCeWrapperWrapper.defaultProps = {
    className: undefined,
    header: undefined,
  };

  return WithCeWrapperWrapper;
};

export default withCeWrapper;
